export const mapInputsToAddressHU = (addressFormInputs) => {
	const { street, houseNumber, building, apartment, floor, addressLine2 } =
		addressFormInputs;

	const normalizedFloor = floor
		? /\b(fszt|fsz|földszint|emelet|em)\b/i.test(floor)
			? floor
			: `${floor}. emelet`
		: null;

	const normalizedApartment = apartment
		? /\bajtó|lakás\b/i.test(apartment)
			? apartment
			: `${apartment}. ajtó`
		: null;

	const parts = [
		[street, houseNumber].filter(Boolean).join(' '),
		building || null,
		normalizedFloor,
		normalizedApartment,
		addressLine2 || null,
	];

	return parts.filter(Boolean).join(', ');
};
